import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import clsx from 'clsx';
import Icon from '../atoms/Icon';
import Property from '../atoms/Property';
import { useTranslation } from 'next-i18next';
import styles from '../../styles/components/molecules/ProviderListed.module.scss';
import { Venue } from '../../graphql/types';
import Button from '../atoms/Button';
import { cloudflareLoader } from '../atoms/Img';

interface ProviderListedProps {
  className?: string;
  tiny?: boolean;
  small?: boolean;
  medium?: boolean;
  large?: boolean;
  hero?: boolean;
  data: any;
  onClick?: (data: any) => void;
  onRemove?: (data: any) => void;
}

export default function ProviderListed(props: ProviderListedProps) {
  const { t } = useTranslation(['common', 'venue']);
  const { providerListed } = styles;
  const { data, className, onClick } = props;
  const { slug, name, image, status, ifes, specs, country, city } = data;
  const statusStr = !!status ? t(`venue:services:${status}`) : '';
  const classes = clsx(
    providerListed,
    props.medium && styles.medium,
    props.small && styles.small,
    props.tiny && styles.tiny,
    onClick !== undefined && styles.clickable,
    className
  );
  const isRemovable = props.onRemove !== undefined;

  const handleRemove = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    e.preventDefault();
    props.onRemove?.(data);
  };

  return (
    <div
      className={classes}
      onClick={onClick ? () => onClick(data) : undefined}
    >
      <figure>
        <figcaption>
          <p>
            <b>
              <span>{name}</span>
              {!!ifes && <Icon name={'ifes'} />}
            </b>

            {/* {!!statusStr && <Property icon={status} label={statusStr} />} */}
          </p>
          <ul>
            <li>
              {!!statusStr && <Property icon={status} label={statusStr} />}
            </li>

            {/* {specs.map((el: any, i: number) => (
              <li key={i}>
                <Property icon={el.id} value={el.value} unit={el.unit} />
              </li>
            ))} */}
            {/* {<li>
                  <Property icon={'rating'} label="0" unit={`(${0})`} />
                </li>} */}
          </ul>
        </figcaption>

        <div>
          {image ? (
            <Image
              loader={cloudflareLoader}
              src={image}
              alt={'an image'}
              layout="fill"
              objectFit="cover"
            />
          ) : (
            <Icon name="services" />
          )}
        </div>
      </figure>
      {isRemovable && (
        <Button
          small
          dark
          icon="remove"
          label={t('venue:cta-remove-service-provider')}
          onClick={(e) => handleRemove(e)}
        />
      )}
    </div>
  );
}
